<template>
  <PmNotificationResourceRequestUpdatedPure v-bind="{ ...$attrs, ...props }" />
</template>

<script setup lang="ts">
import PmNotificationResourceRequestUpdatedPure, {
  type Props as PropsNotificationResourceRequestUpdatedPure,
} from '@/components/PmNotification/PmNotificationResourceRequestUpdated/PmNotificationResourceRequestUpdatedPure.vue'

export type Props = PropsNotificationResourceRequestUpdatedPure

const props = withDefaults(defineProps<Props>(), {})
</script>
